module.exports = __webpack_public_path__ + "img/banner1.428055f8.jpg";